const useLogic = (stateProps, dispatchProps, screen, setScreen, 
  firstNumber, setFirstNumber, secondNumber, setSecondNumber) => {    
    const {firstOpuest, secondOpuest, comma,
        operation, result, screenInitial, screenStop } = stateProps;
    
    const {setFirstOpuest, setSecondOpuest,
        setComma, setOperation, setResult, setHistory, setScreenInitial, 
        setScreenStop} = dispatchProps;

    const addComma = (string, setFunc) => {
      if(!comma) {
        if(string.length===0){
          setFunc("0.");
          setScreen("0.");
        } else {
          setFunc(`${string}.`);
          setScreen(`${screen}.`);
        }
        setComma(true);
      } 
    }
    
    const commaHandler = (str) => {
      if(/[.]/.test(str)){
        setComma(true);
      }
      else{
        setComma(false);
      }
    }
    
    const addOpuest = (setFunc, str, sign) => {
        const string = str.toString();
        var result = string;
        if(!/[-]/g.test(string)){
          result = string==="0"
            ? `${sign}`
            : `${sign}${string}`;
          setScreen(result.toString());
          setFunc(result.toString());
        }
      setScreenInitial(false);
    };
    
    const removeOpuest = (setFunc, str) => {
      const string = str.toString();
      const stringPrueba = string;
      console.log("remove", stringPrueba.split('-').join(""));
      setFunc(string.split('-').join(""));
      setScreen(screen => {
        const string = screen.toString();
        return string.split('-').join("");
      });
    }
    
    const showHistory = (op) => {
      if((firstNumber && !secondNumber) || secondNumber==="-"){
         setHistory(`${firstNumber} ${op} `);
      }
    }
    
    const showHistoryResult = (firstFilter, operationSol, secondFilter, solutionFilter, op, time) =>{
      var prevHistory = `${firstFilter} ${operationSol} ${secondFilter} = ${solutionFilter}`;
      if(/[/*+-]/.test(op)) prevHistory = `${prevHistory} ${op}`;

      if(prevHistory.length > 29){
        prevHistory = `${firstFilter} ${operationSol} ${secondFilter} = `;
        if(prevHistory.length > 29){
          var firstFilter2 = truncInt(firstFilter);
          var secondFilter2 = truncInt(secondFilter);
          secondFilter2 = /[-]+/g.test(secondFilter) ? `${secondFilter2})` : secondFilter2;
          prevHistory = `${firstFilter2} ${operationSol} ${secondFilter2} = `;
        }
        setTimeout(()=> setHistory(prevHistory), time);
      } else {
        setTimeout(()=> setHistory(prevHistory), time);
      }
    }
    
    const truncInt = (strNum) => {
      //for history
      var str = strNum.toString();
      return str.substring(0, 11);
    }
  
    const truncDecimal = (strNum) => {
      var str = strNum.toString();  
      if(/[.]/.test(str)){
        str = Number.parseFloat(str).toFixed(4).toString();
        if(/0+$/.test(str)){
          str = str.replace(/[0]+$/, "");
        }
        if(/[.]$/.test(str)){
          str = str.replace(/[.]/, "")
        }
      }
      return str;
    };
    
    const getSolution = (first, operation, second, op) =>{  
      var solution = eval(`${first}${operation}(${second})`).toString();
      var solutionFilter = truncDecimal(solution);
      
      var firstFilter = truncDecimal(first);
      var secondFilter = truncDecimal(second);
      secondFilter = /[-]+/g.test(secondFilter) ? `(${secondFilter})` : secondFilter; 
      var operationSol = operation;
     
      if(solutionFilter.length > 16){
        solutionFilter = solutionFilter.substring(0, 16); 
        setHistory("RESULTADO ACORTADO");
        showHistoryResult(firstFilter, operationSol, secondFilter, solutionFilter, op, 2000);
      } else {
        showHistoryResult(firstFilter, operationSol, secondFilter, solutionFilter, op, 0);
      }
      return solutionFilter.toString();
    }
    
    const onClickNumber = (num) => {
      if(screenInitial) {
        if(num==="+/-"){
          result 
            ? commaHandler(firstNumber) 
            : commaHandler(secondNumber);   
        } else {
            !operation && setFirstNumber(""); 
            setScreen("");        
        }
        setResult("");
        setScreenInitial(false); 
      }
      
      screen.length > 14 
        ? setScreenStop(true) 
        : setScreenStop(false);
      
      if(operation===""){
        if(num===".")
          addComma(firstNumber, setFirstNumber);
        else if(num==="0" && firstNumber===""){  }
        else if(num==="+/-"){ 
          if(firstNumber[0]==="-") {
            removeOpuest(setFirstNumber, firstNumber);
          }
          else addOpuest(setFirstNumber, firstNumber, "-");
        } else {
          !screenStop && setFirstNumber(firstNumber => `${firstNumber}${num}`);
          !screenStop && setScreen(screen => `${screen}${num}`);
        }
      } else {
        if(num===".")
          addComma(secondNumber, setSecondNumber);
        else if(num==="0" && secondNumber===""){  }
        else if(num==="+/-"){ 
          secondNumber[0]==="-"
            ? removeOpuest(setSecondNumber, secondNumber)
            : addOpuest(setSecondNumber, secondNumber, "-");
        } else {
          !screenStop && setSecondNumber(secondNumber => `${secondNumber}${num}`);
          !screenStop && setScreen(screen => `${screen}${num}`);
        }
      }
    }
    
    const onClickOperation = (op) => {
        firstNumber && secondNumber && secondNumber!=="-" && onClickEqual(op);
        setScreenStop(false);
        setScreenInitial(true);
        setComma(false);
      if(op==="-"){
        if(firstNumber===""){
          if(result===""){
            !firstOpuest && addOpuest(setFirstNumber, firstNumber, "-");
            !firstOpuest && setFirstOpuest(true);
          }else if(secondNumber===""){
            if(operation!==""){
              !secondOpuest && addOpuest(setSecondNumber, secondNumber, "-");
              !secondOpuest && setSecondOpuest(true);
            } else if(operation===""){
              setOperation(op);
              showHistory(op);
            }
          } else {
            setOperation(op);
            showHistory(op);
          }
        }else if(secondNumber===""){
          if(operation!==""){
            !secondOpuest && addOpuest(setSecondNumber, secondNumber, "-");
            !secondOpuest && setSecondOpuest(true);
          }else if(operation===""){
            setOperation(op);
            showHistory(op);
          }
        }else if(operation==="" || secondNumber){
          setOperation(op);
          showHistory(op);
        }
      }else if(firstNumber || secondNumber){
        if(secondNumber){
          secondOpuest && removeOpuest(setSecondNumber, secondNumber);
          secondOpuest && setSecondOpuest(false);
        }
        setOperation(op);
        showHistory(op);
      }
    }
    
    const onClickEqual = (op) => {
      if(operation){
        const first = firstNumber==="-" ? "-0" : firstNumber ? firstNumber : "0";
        const second = secondNumber ? secondNumber : "0";
        const sol = getSolution(first, operation, second, op);
        setFirstNumber(sol);
        setSecondNumber("");
        setFirstOpuest(false);
        setSecondOpuest(false);
        setOperation("");
        setScreenInitial(true);
        setScreenStop(false);
        setComma(false);
        setScreen(sol);
        setResult(sol);
      }
    }
    
    const onClickDelete = () => { 
      if(firstNumber && !secondNumber){
        commaHandler(firstNumber);
        setFirstNumber(firstNumber.substring(0, firstNumber.length-1));
        setScreen(screen.substring(0, screen.length-1));
      } else if(firstNumber && secondNumber){
        commaHandler(secondNumber);
        setSecondNumber(secondNumber.substring(0, secondNumber.length-1));
        setScreen(screen.substring(0, screen.length-1));
      }
    }
    
    const onClickClear = () => {
      setFirstNumber("");
      setSecondNumber("");
      setFirstOpuest(false);
      setSecondOpuest(false);
      setComma(false);
      setOperation("");
      setHistory("");
      setResult("");
      setScreen("");
      setScreenInitial(true);
      setScreenStop(false);
    }

    return { onClickNumber, onClickOperation, onClickClear, onClickDelete, onClickEqual };
}

export default useLogic;